export enum UserGradeEnum {
  advanced = 3,
  medium = 2,
  beginner = 1,
}
